import { DotationOrderForm } from '../types/dotationOrderForm'

type TranslateFn = (key: string) => string

export function buildNatureRules(t: TranslateFn, getForm: () => DotationOrderForm) {
  return {
    nature: [{ required: true, message: t('newDotationOrder.rules.nature'), trigger: 'change' }],
    ursafEventId: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        if (getForm().nature === 'urssaf' && !value) {
          callback(new Error(t('newDotationOrder.rules.urssafEvent')))
        } else callback()
      },
      trigger: 'change'
    }]
  }
}

export function buildCardOptionsRules(t: TranslateFn, getForm: () => DotationOrderForm) {
  return {
    cardFunding: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        if (getForm().enableBankCard && !value) {
          callback(new Error(t('newDotationOrder.rules.cardFunding')))
        } else callback()
      },
      trigger: 'change'
    }]
  }
}

export function buildDistributionRules(t: TranslateFn) {
  return {
    distributionMode: [{ required: true, message: t('newDotationOrder.rules.distributionMode'), trigger: 'change' }]
  }
}

export function buildEntryRules(t: TranslateFn, getForm: () => DotationOrderForm) {
  return {
    programId: [{ required: true, message: t('newDotationOrder.rules.program'), trigger: 'change' }],
    customerId: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        if (getForm().distributionMode === 'single' && !value) {
          callback(new Error(t('newDotationOrder.rules.customer')))
        } else callback()
      },
      trigger: 'change'
    }],
    amount: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        if (getForm().distributionMode !== 'single') {
          callback()
          return
        }
        const amount = Number(value)
        if (!value || Number.isNaN(amount) || amount <= 0) {
          callback(new Error(t('newDotationOrder.rules.amount')))
        } else callback()
      },
      trigger: 'blur'
    }],
    csvBlob: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        const form = getForm()
        if (form.distributionMode !== 'csv') {
          callback()
        } else if (!value) {
          callback(new Error(t('newDotationOrder.rules.csv')))
        } else if (form.csvHasErrors) {
          callback(new Error(t('newDotationOrder.rules.csvInvalidRows')))
        } else callback()
      },
      trigger: 'change'
    }]
  }
}
